import { useTranslation } from 'next-i18next'

import { HomepageHeadingH1 } from '@/components/homepage/styled'

export const HomepageH1 = () => {
  const { t } = useTranslation('home')

  return <HomepageHeadingH1>{t('heading.h1')}</HomepageHeadingH1>
}
